import { render, staticRenderFns } from "./CompLinebreak.vue?vue&type=template&id=61696879&"
import script from "./CompLinebreak.vue?vue&type=script&lang=ts&"
export * from "./CompLinebreak.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports